module.exports = __webpack_public_path__ + "static/media/md-snow.7f621bff.svg";